/* eslint-disable prettier/prettier */
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const englishMessages = {
  'error.generic': 'Unexpected error occurred in login component.',
  'error.login.generic': 'Login failed. Please try again later.',
  'error.login.validation.authorization': 'Please refer to the administrator of the application to get access granted for your user ID.',
  'error.login.profile.generic': 'User profile could not be retrieved.',
  'error.logout.generic': 'Logout failed. Please try again later.',
};

const germanMessages = {
  'error.generic': 'Unerwarteter Fehler in der Anmeldekomponente aufgetreten.',
  'error.login.generic': 'Anmeldung fehlgeschlagen. Bitte versuchen Sie es später noch einmal.',
  'error.login.validation.authorization': 'Sie haben aktuell keine Berechtigung für die Benutzung dieser Funktionalität. Bitte wenden Sie sich an den Administrator der Anwendung und bitten Ihn um Freischaltung für Ihre Benutzerkennung.',
  'error.login.profile.generic': 'Das Benutzerprofil konnte nicht abgerufen werden.',
  'error.logout.generic': 'Abmeldung fehlgeschlagen. Bitte versuchen Sie es später noch einmal.',
};

const messages = {
  de_DE: germanMessages,
  en_ZA: englishMessages,
};

export default new VueI18n({
  locale: 'de_DE', // set locale
  fallbackLocale: 'en_ZA', // set fallback locale
  messages, // set locale messages
});
